import { IconButton } from '@breezeventures/ui-kit/icon-button';
import cn from 'classnames';

import backIcon from './back-icon.svg';
import closeIcon from './close-icon.svg';
import logo from './logo.svg';

export type ScreenHeaderProps = {
  onBack?: () => void;
  onClose?: () => void;
  singleLogoAlign?: 'left' | 'center';
  className?: string;
};

export const ScreenHeader = ({
  onBack,
  onClose,
  singleLogoAlign = 'center',
  className,
}: ScreenHeaderProps) => {
  const hasAnyAction = !!onBack || !!onClose;

  return (
    <div
      className={cn(
        'flex min-h-16 items-center justify-between bg-white',
        className
      )}
    >
      {hasAnyAction && (
        <div className="min-w-14">
          {onBack && (
            <IconButton
              variant="ghost"
              size="l"
              type="button"
              onClick={onBack}
              aria-label="Go back"
            >
              <img src={backIcon} alt="" className="size-8.5" />
            </IconButton>
          )}
        </div>
      )}

      <div className="grow px-4">
        <img
          src={logo}
          alt="Skyro"
          className={cn('h-8.5 w-auto', {
            'm-auto': hasAnyAction || singleLogoAlign === 'center',
          })}
        />
      </div>
      {hasAnyAction && (
        <div className="min-w-14">
          {onClose && (
            <IconButton
              variant="ghost"
              size="l"
              type="button"
              onClick={onClose}
              aria-label="Close"
            >
              <img src={closeIcon} alt="" className="size-8.5" />
            </IconButton>
          )}
        </div>
      )}
    </div>
  );
};
